import React, { FC, useCallback, useState } from 'react';
import styled from 'styled-components';
import { colors } from '../../constants/colors';
import { FAQItem } from './FAQItem';
import { faq } from './constants';

export const FAQ: FC = () => {
  const [openIndex, setOpenIndex] = useState(-1);

  const onHeaderClick = useCallback(
    (index: number) => {
      setOpenIndex(openIndex === index ? -1 : index);
    },
    [openIndex],
  );

  const list = faq.map(({ title, body }, index) => {
    const isOpened = index === openIndex;
    return (
      <FAQItem key={index} isOpened={isOpened} title={title} onClick={() => onHeaderClick(index)}>
        {body}
      </FAQItem>
    );
  });

  return (
    <StyledFAQ>
      <StyledHeader>Frequently Asked Questions</StyledHeader>
      {list}
    </StyledFAQ>
  );
};

const StyledFAQ = styled.div`
  width: 100%;
  padding: 48px 0;
  background-color: ${colors.lightGrey2};
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const StyledHeader = styled.h2`
  font-size: 64px;
  font-weight: bold;
  height: 100px;
  padding-bottom: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
